import { render, staticRenderFns } from "./MenuTabs.vue?vue&type=template&id=934be1a6&"
import script from "./MenuTabs.vue?vue&type=script&lang=js&"
export * from "./MenuTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mike/Sites/SchulmanTheatres/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('934be1a6')) {
      api.createRecord('934be1a6', component.options)
    } else {
      api.reload('934be1a6', component.options)
    }
    module.hot.accept("./MenuTabs.vue?vue&type=template&id=934be1a6&", function () {
      api.rerender('934be1a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuTabs.vue"
export default component.exports